import { createContext, useEffect, useCallback, useState } from "react";
import {
    Routes,
    Route,
    BrowserRouter as Router
} from "react-router-dom";
import Login from "./home/login";
import MainApp from "./app/app";
import { infoAlert } from "./components/toastr";
import { PageLoading } from "./components/loading";
import { getAuthStatus } from "./resources/api/auth";
import ActivateAccount from "./home/activate";

/**
 * Context containing information about the user profile including, app accesses etc.
 * @type {React.Context<{profile: import("./resources/api/auth").AuthObject, isLoggedIn: boolean}>}
 */

const AppUserContext = createContext();

export const user = {
    other_names: "Maurice Musazi",
    last_name: "Ntege",
    display_name: "Maurice M Ntege",
    email: "morsnegs@hotmail.com",
    job_title: "Engineer",
    permission_level: 1,
    roles: ["finance"]
}



/**
 * Main App
 */
const App = () => {


    const [isLoggedIn, setLoggedIn] = useState(false);
    const [profile, setProfile] = useState({});
    const [loaded, setLoaded] = useState(false);

    const loginUser = useCallback((details) => {
        setProfile({ ...details });
        setLoggedIn(true);
    }, [])

    const logoutUser = useCallback(() => {
        setProfile({});
        setLoggedIn(false);
    }, [])

    useEffect(() => {
        getAuthStatus()
            .then(({ user_details }) => {
                setProfile({ ...user_details });
                setLoggedIn(true);
            })
            .catch(() => {
                infoAlert("Please log in to continue");
                setLoggedIn(false);
            })
            .finally(() => setLoaded(true))
    }, [])

    if (!loaded) return <PageLoading>Loading your app</PageLoading>;

    return (
        <AppUserContext.Provider value={{ profile, isLoggedIn }} >
            <Router>
                <Routes>
                    <Route
                        path="/app/*"
                        element={<MainApp logoutUser={logoutUser} />}
                    />
                    <Route
                        path="/activate"
                        element={<ActivateAccount loginUser={loginUser} />}
                    />
                    <Route
                        path="/"
                        element={<Login loginUser={loginUser} />}
                    />
                </Routes>
            </Router>
        </AppUserContext.Provider>
    );
}

export { AppUserContext };
export default App;